'use strict';
window._theme = window._theme || {};

_theme.initHeaderRewardEvents = function () {
  const rewardsItem = document.querySelector('li.rewards-item');
  const rewardsLink = rewardsItem?.querySelector('a.rewards');
  const rewardsToggleBtn = rewardsItem?.querySelector('[data-toggle-rewards-menu]');
  const rewardsDropdown = rewardsItem?.querySelector('.rewards_dropdown_main');
  const loginBtn = document.querySelector('.rewards_dropdown_main .login');
  const loginBtnClose = document.querySelector('.rewards-popups div#rModal button.rClose');
  const signupBtn = document.querySelector('.rewards_dropdown_main .sign-up');
  const signupBtnClose = document.querySelector('.rewards-popups div#srModal button.srClose');
  const dropdownFocusableSelector =
    'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const focusFirstDropdownItem = () => {
    const firstFocusable = rewardsDropdown?.querySelector(dropdownFocusableSelector);
    if (firstFocusable) firstFocusable.focus();
  };

  const setRewardsExpanded = (isExpanded) => {
    const expanded = isExpanded ? 'true' : 'false';
    rewardsToggleBtn?.setAttribute('aria-expanded', expanded);
    rewardsDropdown?.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
    rewardsItem?.classList.toggle('is-open', isExpanded);
  };

  if (rewardsItem && rewardsLink && rewardsDropdown && rewardsToggleBtn) {
    setRewardsExpanded(false);

    rewardsToggleBtn.addEventListener('click', function (event) {
      event.preventDefault();
      const isExpanded = rewardsToggleBtn.getAttribute('aria-expanded') === 'true';
      setRewardsExpanded(!isExpanded);
    });

    rewardsToggleBtn.addEventListener('keydown', function (event) {
      const isExpanded = rewardsToggleBtn.getAttribute('aria-expanded') === 'true';

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (!isExpanded) setRewardsExpanded(true);
        focusFirstDropdownItem();
      }

      if (event.key === 'Tab' && !event.shiftKey && isExpanded) {
        event.preventDefault();
        focusFirstDropdownItem();
      }
    });

    rewardsItem.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setRewardsExpanded(false);
        rewardsToggleBtn.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!rewardsItem.contains(event.target)) setRewardsExpanded(false);
    });
  }

  if (loginBtn) {
    loginBtn.addEventListener('click', function () {
      document.querySelector('.rewards-popups div#rModal').classList.add('active');
    });
    loginBtn.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      document.querySelector('.rewards-popups div#rModal').classList.add('active');
    });
  }

  if (loginBtnClose) {
    loginBtnClose.addEventListener('click', function () {
      document.querySelector('.rewards-popups div#rModal').classList.remove('active');
    });
  }

  if (signupBtn) {
    signupBtn.addEventListener('click', function () {
      document.querySelector('.rewards-popups div#srModal').classList.add('active');
    });
    signupBtn.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      document.querySelector('.rewards-popups div#srModal').classList.add('active');
    });
  }

  if (signupBtnClose) {
    signupBtnClose.addEventListener('click', function () {
      document.querySelector('.rewards-popups div#srModal').classList.remove('active');
    });
  }
};

$(document).ready(function () {
  function getHeightofElement(element, setElementHeight) {
    // Convert jQuery object to DOM element if needed
    const domElement = element instanceof jQuery ? element[0] || element.get(0) : element;
    if (!domElement) return;

    const height = domElement.offsetHeight;

    if (setElementHeight) {
      // setElementHeight: can be a single element or a collection (jQuery object, Array, or NodeList)
      if (
        setElementHeight instanceof jQuery ||
        (typeof NodeList !== 'undefined' && setElementHeight instanceof NodeList) ||
        Array.isArray(setElementHeight)
      ) {
        // If it's a collection, iterate and set height for each element
        const elementsArray =
          setElementHeight instanceof jQuery
            ? setElementHeight.toArray()
            : Array.from(setElementHeight);
        elementsArray.forEach(function (el) {
          if (el && el.style) {
            el.style.height = height + 'px';
          }
        });
      } else if (setElementHeight && setElementHeight.style) {
        // Single element
        setElementHeight.style.height = height + 'px';
      }
    } else {
      return height;
    }
  }
  if (!($('.bps-deals-list').hasClass('product-in-rows') && $(window).width() > 768)) {
    $('.bps-deals-list').removeClass('product-in-rows');
  }

  const $bpsItem = $('.bps-deals-list .item').first();
  const $bpsCard = $('.bps-deals-card');
  if ($bpsItem.length && $bpsCard.length && window.innerWidth > 768) {
    getHeightofElement($bpsItem, $bpsCard);
  }



  const targetNode = document.querySelector('.be-ix-link-block');
  if (targetNode) {
    const observerR = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          document.querySelector('.be-list')?.setAttribute('role', 'list');
          document
            .querySelectorAll('.be-list-item')
            ?.forEach((el) => el?.setAttribute('role', 'listitem'));
        }
      });
    });
    observerR.observe(targetNode, { childList: true, subtree: true });
  }
});

document.addEventListener('DOMContentLoaded', function (event) {
  _theme.initHeaderRewardEvents();

  const phoneInputs = document.querySelectorAll('form input[name="customer[note][phone number]"]');
  phoneInputs.forEach(function (input) {
    input.addEventListener('blur', function (evt) {
      if (!this.value) return;
      const phoneNum = Number(this.value.trim());
      if (!phoneNum) return;
      _theme.Helpers.setCookie('cphone', phoneNum, 7);
    });
  });

  /* account mobile sidebar */
  function MobileSidebar() {
    const button_account = document.querySelectorAll('#log-in-form .button-account');
    button_account.forEach((btn) => {
      btn.addEventListener('click', () => {
        const tab = btn.getAttribute('tab');
        document
          .querySelectorAll('.account-box')
          .forEach((box) => box.classList.add('mobile-hide'));
        document.querySelector(`#${tab}`).classList.remove('mobile-hide');
        const btn_sign_reg = btn.closest('.btn-sign-reg') || btn.closest('.cm-bottom-in-up');
        if (btn_sign_reg) {
          document.querySelector('.back-btn').classList.remove('visibility-hidden');
        } else {
          document.querySelector('.back-btn').classList.add('visibility-hidden');
        }
      });
    });

    const account_btn = document.querySelector('.account-btn[customer="true"]');
    if (account_btn) {
      account_btn.addEventListener('click', (e) => {
        if (window.screen.width > 767) {
          e.preventDefault();
          window.location.href = '/account';
        }
      });
    }
  }
  MobileSidebar();
  /* end account mobile sidebar */
  /* category read more */
  function CategoryReadMore() {
    const categoryDesc = document.querySelectorAll('.category-desc-home');
    const categoryReadMore = document.querySelectorAll('.categ-read-more');
    if (categoryDesc && categoryReadMore) {
      categoryReadMore.forEach((readMore) => {
        readMore.addEventListener('click', (e) => {
          e.preventDefault();
          e.target.parentElement.classList.toggle('show-more');
          e.target.parentElement.querySelector('.categ-read-more').textContent =
            e.target.parentElement.classList.contains('show-more') ? 'Read less' : 'Read more';
        });
      });
    }
  }
  setTimeout(() => {
    CategoryReadMore();
  }, 1000);
  /* end category read more */
});

/* header-lock */
const header = document.querySelector('.site-header .header-bottom');
const sticky = header.offsetTop;
window.onscroll = function () {
  if (window.scrollY > sticky) {
    header.classList.add('header-lock');
  } else {
    header.classList.remove('header-lock');
  }
};
/* end header-lock */